import React from "react"
import { Select } from "antd"
import { useCollection } from "../../../../hooks/useCollection"

const { Option } = Select

export default function SelectUser({ selectedUser, setSelectedUser }) {
  const { data, loading } = useCollection("users", ["group", "array-contains", "sales"])

  // make sure we always have an array
  const users = Array.isArray(data) ? data : []

  const handleChange = (value, record) => {
    setSelectedUser(value)
  }

  return (
    <Select
      showSearch
      value={selectedUser}
      loading={loading}
      placeholder="Select sales user"
      style={{ minWidth: 220 }}
      optionFilterProp="children"
      onChange={(value, options) => handleChange(value, options)}
      filterOption={(input, opt) => opt?.children?.toLowerCase().includes(input.toLowerCase())}>
      <Option key="all" value="all">
        All users
      </Option>

      {users.map((u) => (
        <Option key={u.id ?? u.uid} value={u.id ?? u.uid}>
          {u.displayName || u.email}
        </Option>
      ))}
    </Select>
  )
}
